import React from 'react'
import './testimonials.css'
import AVTR1 from '../../assets/avatar.jpg'
import AVTR2 from '../../assets/woman_avatar.jpg'

  // core version + navigation, pagination modules:
  import {  Pagination } from 'swiper';

  import {Swiper,SwiperSlide  }from 'swiper/react';
  // import Swiper and modules styles

  import 'swiper/css';

  import 'swiper/css/pagination';



const data = [
    {
        avatar: AVTR1,
        name: 'Abdullahi O. Abdulkareem',
        review: 'Victor is exceptional, working with him is very easy. He delivers pixel perfect mobile screens and always passionate about his work.I am confident to say Victor is an asset to any team.'
    },

    {
        avatar: AVTR2,
        name: 'Daniel Oludiya',
        review: 'Victor provided top quality, thoughtful and high impact design work with outstanding attention to detail. Wouldn’t hesitate to recommend.'
    },

    {
        avatar: AVTR1,
        name: 'Banjo Oluwatimilehin',
        review: 'It has been a real pleasure working with Ian. He has been very professional and very clear in all communications, which I appreciate.'
    },

    {
        avatar: AVTR2,
        name: 'Lyon Koledoye',
        review: 'The work we received from him was top-notch, thoroughly documented and definitely one of the best developers on the team'
    }
]

const Testimonials = () => {
    return (
        <section id='testimonials'>
            <h5>Review from clients and colleagues</h5>
            <h2>Testimonials</h2>

            <Swiper 
            pagination = {{clickable: true}}
            spaceBetween = {50}
            slidesPerView={1}
            modules= {[Pagination]}
           
         
            className='container testimonials__container'>
                

                {
                    data.map(({ avatar, name, review }, index) => {
                        return (
                            <SwiperSlide key={index} className='testimonial'>
                                <div className='client__avatar'>
                                    <img src={avatar} alt="Avater One" />
                                </div>
                                <h5 className='client__name'>{name}</h5>
                                <small className='client__review'>
                                    {review}
                                </small>
                            </SwiperSlide>
                        )
                    }
                    )
                }
            </Swiper>
        </section>
    )

}

export default Testimonials